import { Container, Grid, Button, Card, CardContent, Typography, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from "@mui/material";
import React, { useState, useEffect } from "react";
import { NavBar } from "../../common/NavBar";
import { useNavigate } from "react-router-dom";  // Importar useNavigate

export const ActoresPage: React.FC<{}> = () => {
    const [actors, setActors] = useState<{ _id: string; name: string; description: string; skills: string }[]>([]);
    const [open, setOpen] = useState(false);
    const [formValues, setFormValues] = useState({ name: '', description: '', skills: '' });
    const navigate = useNavigate();  // Inicializar useNavigate

    useEffect(() => {
        // Función para obtener los actores desde el backend
        const fetchActors = async () => {
            try {
                const response = await fetch('http://localhost:5000/api/actors');
                const data = await response.json();
                setActors(data);
            } catch (error) {
                console.error('Error al obtener los actores:', error);
            }
        };

        fetchActors();
    }, []);

    const handleAddActor = async () => {
        try {
            const response = await fetch('http://localhost:5000/api/addActor', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formValues),
            });

            if (!response.ok) {
                throw new Error('Error al guardar los datos');
            }

            const newActor = await response.json();
            setActors([...actors, { _id: newActor._id, ...formValues }]);
            setOpen(false);
            setFormValues({ name: '', description: '', skills: '' });

        } catch (error) {
            console.error('Error al guardar los datos:', error);
        }
    };

    const handleCardClick = (id: string) => {
        // Navegar a la página de detalles del actor usando useNavigate
        navigate(`/actors/${id}`);
    };

    return (
        <>
            <NavBar />
            <Container maxWidth="xl">
                <Grid container direction={"column"} alignItems={"center"} justifyContent={"center"}>
                    <Grid item sx={{ mt: 5 }}>
                        <Button variant="contained" onClick={() => setOpen(true)}>Agregar Actor</Button>
                    </Grid>
                    <Grid container spacing={2} sx={{ mt: 2 }}>
                        {actors.map((actor) => (
                            <Grid item key={actor._id} onClick={() => handleCardClick(actor._id)}>
                                <Card sx={{ width: 250, height: 400, cursor: 'pointer' }}>
                                    <CardContent>
                                        <Typography variant="h5" component="div">
                                            
                                        </Typography>
                                        <Typography variant="h6" component="div">
                                            {actor.name}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {actor.description}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            Conocimientos: {actor.skills}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Container>

            {/* Modal con formulario */}
            <Dialog open={open} onClose={() => setOpen(false)}>
                <DialogTitle>Agregar Actor</DialogTitle>
                <DialogContent>
                    <TextField
                        margin="dense"
                        name="name"
                        label="Nombre"
                        fullWidth
                        value={formValues.name}
                        onChange={(e) => setFormValues({ ...formValues, name: e.target.value })}
                    />
                    <TextField
                        margin="dense"
                        name="description"
                        label="Descripción"
                        fullWidth
                        value={formValues.description}
                        onChange={(e) => setFormValues({ ...formValues, description: e.target.value })}
                    />
                    <TextField
                        margin="dense"
                        name="skills"
                        label="Conocimientos"
                        fullWidth
                        value={formValues.skills}
                        onChange={(e) => setFormValues({ ...formValues, skills: e.target.value })}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>Cancelar</Button>
                    <Button variant="contained" onClick={handleAddActor}>Guardar</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
